import { Model, useRepo } from 'pinia-orm';
import { useCommonStore } from "../../shared/state/common";
import Competence from "./Competence";
import CompetenceTemplateCompetence from "./CompetenceTemplateCompetence";

export default class CompetenceTemplate extends Model {

    static get entity() {
        return 'competence-templates';
    }

    static fields() {
        return {
            id: this.uid(),
            title: this.attr({}),
            default: this.attr({}),
            order: this.attr({}),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationships
            competences: this.belongsToMany(Competence, CompetenceTemplateCompetence, 'competence_template_id', 'competence_id'),
            jobs: this.attr([]),
        }
    }

    get titleLocale() {
        const commonStore = useCommonStore();
        return this.title[commonStore.locale] || null;
    }

    static detach(id) {
        useRepo(CompetenceTemplateCompetence).destroy(id);
    }
}
